var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTwitterWhite = function SvgTwitterWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "white",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03168 13C11.0694 13 14.3718 7.99812 14.3718 3.66052C14.3718 3.51845 14.3718 3.37702 14.3622 3.23623C15.0047 2.77156 15.5593 2.19622 16 1.53715C15.4009 1.8026 14.7653 1.97669 14.1146 2.05359C14.7998 1.64337 15.3127 0.998162 15.5578 0.238043C14.9134 0.620387 14.2084 0.889844 13.4733 1.03479C12.4557 -0.047124 10.8389 -0.311925 9.52931 0.388867C8.21976 1.08966 7.54322 2.58176 7.87904 4.02849C5.23961 3.89618 2.78046 2.6496 1.1136 0.598977C0.242319 2.0988 0.687352 4.01752 2.12992 4.98074C1.60751 4.96526 1.0965 4.82434 0.64 4.56989C0.64 4.58333 0.64 4.59741 0.64 4.61149C0.640428 6.17399 1.74192 7.51978 3.2736 7.82917C2.79032 7.96097 2.28325 7.98023 1.79136 7.88549C2.22141 9.22262 3.45381 10.1386 4.85824 10.165C3.69583 11.0785 2.25988 11.5744 0.78144 11.5729C0.520258 11.5724 0.259331 11.5566 0 11.5255C1.50121 12.4889 3.24794 12.9998 5.03168 12.9974"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitterWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter_white.add77f51.svg";
export { ForwardRef as ReactComponent };